


















import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    accept: {
      type: String,
      default: '*'
    },
    value: {
      type: File
    },
    chooseLabel: {
      type: String,
      default: 'Choose File'
    }
  }
})
export default class FileUploadLabel extends Vue {
  selectedFile: File | null = null;

  selectFile (event: any) {
    const file = event.target.files[0]
    this.selectedFile = file
    this.$emit('select', file)
  }

  openChooseDialog () {
    (this.$refs.fileEl as any).click()
  }

  updated () {
    this.initFile()
  }

  mounted () {
    this.initFile()
  }

  initFile () {
    if (this.$props.value) {
      this.selectedFile = this.$props.value
    }
  }
}
